export const propPanel = {
    schema: ({ i18n }) => {
        return {
            section: {
                title: i18n('schemas.section'),
                type: 'string',
                widget: 'Input',
                span: 24,
                required: true,
            },
            appRender: {
                type: 'object',
                properties: {
                    label: {
                        title: i18n('schemas.label'),
                        type: 'string',
                        widget: 'Input',
                        span: 24,
                        required: true,
                    },
                },
            }
        };
    },
    defaultSchema: {
        type: 'Signature',
        name: '',
        position: { x: 0, y: 0 },
        width: 62.5,
        height: 37.5,
        section: "",
        appRender: {
            label: '',
            data: '',
        },
    },
};
//# sourceMappingURL=propPanel.js.map